import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DesignSystemModule } from '@inyova/design-system';
import { InyovaSharedModule } from '@inyova/inyova-shared';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';

import * as fromComponents from './components';

@NgModule({
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateModule, IonicModule, DesignSystemModule, InyovaSharedModule],
  declarations: [...fromComponents.components],
  exports: [...fromComponents.components],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CommonGrowModule {}
